import { MutationTree } from "vuex";

import { State } from "./state";
import { GeneralMutationTypes as MutationTypes } from "./mutation-types";

export type EnumItem = { label: string; value: string | number };
export type SetEnumPayload = { name: string; data: EnumItem[] };

export type Mutations<S = State> = {
  [MutationTypes.SET_SIDEBAR_STATUS](state: S, payload: string): void;
  [MutationTypes.SET_FILTER_STATUS](state: S, payload: boolean): void;
  [MutationTypes.SET_LOADER_STATUS](state: S, payload: boolean): void;
  [MutationTypes.SET_COMPANIES](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SECTIONS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SITES](state: S, payload: Array<any>): void;
  [MutationTypes.SET_GROUPS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_COMPANY_ASSETS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SETTINGS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SMTP_SETTINGS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_ALERT](state: S, payload: any): void;
  [MutationTypes.SET_SELECTED_ROW](state: S, payload: any): void;
  [MutationTypes.SET_PERMISSION_LEVELS](state: S, payload: any): void;
  [MutationTypes.SET_REVIEW_STATUSES](state: S, payload: any): void;
  [MutationTypes.SET_RISK_LEVELS](state: S, payload: any): void;
  [MutationTypes.SET_SCOPE_DETAIL](state: S, payload: any): void;
  [MutationTypes.SET_AGMS_BREADCRUMB_STATUS](state: S, payload: any): void;
  [MutationTypes.SET_AGMS_BREADCRUMB_DATA](state: S, payload: any): void;
  [MutationTypes.SET_USERS](state: S, payload: any): void;
  [MutationTypes.SET_PARTNERS](state: S, payload: any): void;
  [MutationTypes.SET_COMPKEY](state: S, payload: any): void;
  [MutationTypes.SET_ROW_OPENED](state: S, payload: any): void;
  [MutationTypes.SET_SELECTED_DECISION](state: S, payload: any): void;
  [MutationTypes.SET_EXPORT_STATUS](state: S, payload: any): void;
  [MutationTypes.SET_EXPORT_DATA_LOADED](state: S, payload: any): void;
  [MutationTypes.SET_APPGROUPS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUPS_PROCESS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUPS_FILE_ACCESS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUPS_REGISTRY_ACCESS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUPS_CODE_LOAD](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUPS_CHILD_LAUNCH](state: S, payload: Array<any>): void;
  [MutationTypes.SET_GLOBAL_POLICIES](state: S, payload: Array<any>): void;
  [MutationTypes.SET_GLOBAL_POLICY_FILE_ACCESS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_GLOBAL_POLICY_REGISTRY_ACCESS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_GLOBAL_POLICY_CODE_LOAD](state: S, payload: Array<any>): void;
  [MutationTypes.SET_ENUM](state: S, payload: SetEnumPayload): void;
  [MutationTypes.SET_FOLDER_MAPS](state: S, payload: Array<any>): void;
  [MutationTypes.SET_PUBLISHER_LIST](state: S, payload: Array<any>): void;
  [MutationTypes.SET_APPGROUP_INFO](state: S, payload: any): void;
  [MutationTypes.RESET_APP_GROUPS](state: S): void;
  [MutationTypes.SET_FILE_TYPES_POLICIES](state: S, payload: Array<any>): void;
  [MutationTypes.SET_INHERITANCE_INFO](state: S, payload: any): void;
  [MutationTypes.SET_TEMPLATE_IS_DEFAULT](state: S, payload: any): void;
  [MutationTypes.SET_TEMPLATE_POLICY_IS_DEFAULT](state: S, payload: any): void;
  [MutationTypes.SET_REMOVABLE_MEDIA](state: S, payload: any): void;
  [MutationTypes.SET_SUMMARY_EVENT_RULES](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SUMMARY_EVENT_INFO](state: S, payload: Array<any>): void;
  [MutationTypes.SET_SUMMARY_EVENT_ENTITY_DATA](state: S, payload: any): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_SIDEBAR_STATUS](state, payload: string) {
    state.sidebarStatus = payload;
  },
  [MutationTypes.SET_FILTER_STATUS](state, payload: boolean) {
    state.filterStatus = payload;
  },
  [MutationTypes.SET_LOADER_STATUS](state, payload: boolean) {
    state.loader = payload;
  },
  [MutationTypes.SET_COMPANIES](state, payload: any) {
    state.companies = payload;
  },
  [MutationTypes.SET_SECTIONS](state, payload: any) {
    state.sections = payload;
  },
  [MutationTypes.SET_SITES](state, payload: any) {
    state.sites = payload;
  },
  [MutationTypes.SET_GROUPS](state, payload: any) {
    state.groups = payload;
  },
  [MutationTypes.SET_COMPANY_ASSETS](state, payload: any) {
    state.companyAssets = payload;
  },
  [MutationTypes.SET_SETTINGS](state, payload: any) {
    state.settings = payload;
  },
  [MutationTypes.SET_SMTP_SETTINGS](state, payload: any) {
    state.smtpSettings = payload;
  },
  [MutationTypes.SET_ALERT](state, payload: any) {
    state.alert = payload;
  },
  [MutationTypes.SET_SELECTED_ROW](state, payload: any) {
    state.selectedExpandedRow = payload;
  },
  [MutationTypes.SET_PERMISSION_LEVELS](state, payload: any) {
    state.permissionLevels = payload;
  },
  [MutationTypes.SET_REVIEW_STATUSES](state, payload: any) {
    state.reviewStatuses = payload;
  },
  [MutationTypes.SET_RISK_LEVELS](state, payload: any) {
    state.riskLevels = payload;
  },
  [MutationTypes.SET_SCOPE_DETAIL](state, payload: any) {
    state.scopeDetail = payload;
  },
  [MutationTypes.SET_AGMS_BREADCRUMB_STATUS](state, payload: any) {
    state.agmsBreadcrumbStatus = payload;
  },
  [MutationTypes.SET_AGMS_BREADCRUMB_DATA](state, payload: any) {
    state.agmsBreadcrumbData = payload;
  },
  [MutationTypes.SET_USERS](state, payload: any) {
    state.users = payload;
  },
  [MutationTypes.SET_PARTNERS](state, payload: any) {
    state.partners = payload;
  },
  [MutationTypes.SET_COMPKEY](state, payload: any) {
    state.compKey = payload;
  },
  [MutationTypes.SET_EXPORT_STATUS](state, payload: any) {
    state.exportStatus = payload;
  },
  [MutationTypes.SET_ROW_OPENED](state, payload: any) {
    state.rowOpened = payload;
  },
  [MutationTypes.SET_SELECTED_DECISION](state, payload: any) {
    state.selectedDecision = payload;
  },
  [MutationTypes.SET_EXPORT_DATA_LOADED](state, payload: any) {
    state.exportDataLoaded = payload;
  },
  [MutationTypes.SET_ISCREATED_MODAL](state, payload: any) {
    state.isModalCreate = payload;
  },
  [MutationTypes.SET_SCOPE_MODAL](state, payload: any) {
    state.scopeModalStatus = payload;
  },
  [MutationTypes.SET_APPGROUPS](state, payload: any) {
    state.appGroups = payload;
  },
  [MutationTypes.SET_APPGROUPS_PROCESS](state, payload: any) {
    state.appGroupsProcess = payload;
  },
  [MutationTypes.SET_APPGROUPS_FILE_ACCESS](state, payload: any) {
    const sorted = (payload || []).slice().sort((a: any, b: any) => {
      const aHasProcess = a.processId !== null && a.processId !== undefined;
      const bHasProcess = b.processId !== null && b.processId !== undefined;
      if (aHasProcess === bHasProcess) return 0;
      return aHasProcess ? 1 : -1;
    });
    state.appGroupsFileAccess = sorted;
  },
  [MutationTypes.SET_APPGROUPS_REGISTRY_ACCESS](state, payload: any) {
    state.appGroupsRegistryAccess = payload;
  },
  [MutationTypes.SET_APPGROUPS_CODE_LOAD](state, payload: any) {
    state.appGroupsCodeLoad = payload;
  },
  [MutationTypes.SET_APPGROUPS_CHILD_LAUNCH](state, payload: any) {
    state.appGroupsChildLaunch = payload;
  },
  [MutationTypes.SET_GLOBAL_POLICIES](state, payload: any) {
    state.globalPolicies = payload;
  },
  [MutationTypes.SET_GLOBAL_POLICY_FILE_ACCESS](state, payload: any) {
    state.globalPolicyFileAccess = payload;
  },
  [MutationTypes.SET_GLOBAL_POLICY_REGISTRY_ACCESS](state, payload: any) {
    state.globalPolicyRegistryAccess = payload;
  },
  [MutationTypes.SET_GLOBAL_POLICY_CODE_LOAD](state, payload: any) {
    state.globalPolicyCodeLoad = payload;
  },
  [MutationTypes.SET_ENUM](state, payload: { name: string; data: EnumItem[] }) {
    state.enums[payload.name] = payload.data;
  },
  [MutationTypes.SET_FOLDER_MAPS](state, payload: []) {
    state.folderMaps = payload;
  },
  [MutationTypes.SET_PUBLISHER_LIST](state, payload: []) {
    state.publisherList = payload;
  },
  [MutationTypes.SET_APPGROUP_INFO](state, payload: any) {
    state.appGroupInfo = payload;
  },
  [MutationTypes.RESET_APP_GROUPS](state) {
    state.appGroupsProcess = [];
    state.appGroupsFileAccess = [];
    state.appGroupsRegistryAccess = [];
    state.appGroupsCodeLoad = [];
    state.appGroupsChildLaunch = [];
  },
  [MutationTypes.SET_FILE_TYPES_POLICIES](state, payload: any) {
    state.fileTypesPolicies = payload;
  },
  [MutationTypes.SET_INHERITANCE_INFO](state, payload: any) {
    state.inheritanceInfo = payload;
  },
  [MutationTypes.SET_TEMPLATE_IS_DEFAULT](state, payload: any) {
    state.isTemplateDefault = payload;
  },
  [MutationTypes.SET_TEMPLATE_POLICY_IS_DEFAULT](state, payload: any) {
    state.isTemplatePolicyDefault = payload;
  },
  [MutationTypes.SET_REMOVABLE_MEDIA](state, payload: any) {
    state.removableMedia = payload;
  },
  [MutationTypes.SET_SUMMARY_EVENT_RULES](state, payload: any) {
    state.summaryEventRules = payload;
  },
  [MutationTypes.SET_SUMMARY_EVENT_INFO](state, payload: any) {
    state.summaryEventInfo = payload;
  },
  [MutationTypes.SET_SUMMARY_EVENT_ENTITY_DATA](state, payload: any) {
    state.summaryEventEntityData = payload;
  }
  
};
